




import { defineComponent } from '@vue/composition-api'

/**
 * 共通 オーバーレイメッセージ テンプレート
 */
export default defineComponent({
  name: 'OverlayMessageParts',
  props: {
    message: {
      type: String,
      default: '',
    },
  },
})
